import React from 'react';

const StructuredData = () => {
  const organizationData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "MedQuore",
    "description": "Leading medical device quality and compliance company specializing in ISO 13485, EU MDR, and FDA regulatory affairs.",
    "url": "https://medquore.com",
    "logo": "https://medquore.com/logo-header.png",
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "contact@medquore.com",
      "contactType": "Customer Service",
      "availableLanguage": "English"
    },
    "address": {
      "@type": "PostalAddress",
      "addressCountry": ["US", "EU", "MENA"]
    },
    "sameAs": [
      "https://medquore.com"
    ],
    "foundingDate": "2024",
    "industry": "Medical Device Compliance",
    "areaServed": ["United States", "European Union", "MENA Region"],
    "knowsAbout": [
      "ISO 13485",
      "EU MDR",
      "FDA Compliance",
      "Medical Device Quality",
      "Regulatory Affairs",
      "Quality Management Systems",
      "Medical Device Auditing"
    ]
  };

  const servicesData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Medical Device Quality & Compliance Services",
    "description": "Comprehensive quality assurance, regulatory compliance, and audit support for medical device companies.",
    "provider": {
      "@type": "Organization",
      "name": "MedQuore"
    },
    "areaServed": ["United States", "European Union", "MENA Region"],
    "serviceType": [
      "Quality Assurance",
      "Global Supplier Audit Support", 
      "Mock Audits & Inspections",
      "Gap Assessments",
      "Training & Leadership",
      "Talent Acquisition & Marketplace"
    ]
  };

  const websiteData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "MedQuore",
    "url": "https://medquore.com",
    "description": "Leading the way in safety and quality for medical devices, drugs, and biologics",
    "publisher": {
      "@type": "Organization",
      "name": "MedQuore"
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://medquore.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(servicesData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteData) }}
      />
    </>
  );
};

export default StructuredData;